import MuiChip from '@mui/material/Chip';

import { getTypographyStyles, styled } from 'helpers';

import { Props } from './types';

export const Chip = styled(MuiChip, {
  shouldForwardProp: (prop) => prop !== 'size',
})<Props>`
  background-color: ${({ theme }) => theme.palette.grey.A50};
  border-radius: 3.75rem;
  color: ${({ theme }) => theme.palette.blueGrey['900']};

  .MuiAvatar-root {
    font-size: 0.5rem;
    font-weight: ${({ theme }) => theme.typography.fontWeightBold};
    line-height: 0.625rem;
    margin-right: ${({ theme }) => theme.spacing(-1)};
  }

  .MuiChip-icon {
    color: ${({ theme }) => theme.palette.blueGrey['A400']};
    margin-left: ${({ theme }) => theme.spacing(1.75)};
    margin-right: ${({ theme }) => theme.spacing(-1)};
  }

  .MuiChip-label {
    ${({ size, theme }) => size !== 'small' && getTypographyStyles('body2', theme)}

    margin-top: -2px;
    max-width: 10.5625rem;
    padding: 0 0.75rem 0 1rem;
  }

  .MuiChip-deleteIcon {
    color: ${({ theme }) => theme.palette.blueGrey['A400']};
    height: 1rem;
    width: 1rem;
  }

  &.MuiChip-colorError {
    background-color: ${({ theme }) => theme.palette.deepOrange['50']};

    .MuiChip-deleteIcon {
      color: ${({ theme }) => theme.palette.pink['700']};
    }
  }
`;
Chip.displayName = 'Chip';

export default Chip;
